import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS, FONTS, WIDTH_DIMENSIONS } from '../../constants'

export const styles = makeStyles(theme => ({
  dropDownContainer: {
    marginTop: theme.spacing(5),
    width: '100%',
    margin: 'auto',
    position: 'relative',
  },
  container: {
    padding: '2rem 0',
    position: 'absolute',
    width: '100%',
    background: '#fff',
    boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.1)',
    left: 0,
    right: 0,
    zIndex: 120,
    maxHeight: '75vh',
    minHeight: '82.5vh',
    overflowY: 'auto',
  },
  shopMenuContainer: {
    display: 'flex',
    width: '90%',
    justifyContent: 'space-between',
    right: 0,
    left: 0,
    zIndex: 1000,
    maxWidth: 1650,
    margin: 'auto',
    maxHeight: '75vh',
  },
  shopMenuColContainer: {
    position: 'relative',
    maxWidth: 330,
  },
  shopMenuLink: {
    textDecoration: 'none',
    color: COLORS.black,
  },
  shopMenuHeading: {
    borderBottom: '1px solid black',
    [`@media (max-width: ${BREAKPOINTS.xl}px)`]: {
      fontSize: '2.5rem',
    },
  },
  shopMenuItemIcon: {
    width: 80,
    height: 80,
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: -1,
    borderRadius: 5,
  },
  fashion: {
    right: -67,
    top: 41,
    background: '#FEF2F3',
  },
  home: {
    right: -67,
    top: 0,
    background: '#E7EFED',
  },
  beauty: {
    right: -67,
    top: 20,
    background: '#FDE4E3',
  },
  lifestyle: {
    top: 0,
    right: -56,
    background: '#D1DEE3',
  },
  brandsIcon: {
    top: 35,
    right: -56,
    background: '#FAD9D9',
  },
  header: {
    width: '100%',
    top: -1,
    zIndex: 100,
  },
  headerFull: {
    background: COLORS.white,
  },
  headerMinimized: {
    background: COLORS.whiteStain,
    position: '-webkit-sticky',
    // @ts-ignore
    position: 'sticky',
  },
  listItem: {
    display: 'block',
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    textDecoration: 'none',
    background: 'transparent',
    border: 'none',
    color: theme.palette.common.black,
    textTransform: 'uppercase',
    letterSpacing: '0.88px',
    cursor: 'pointer',
    textAlign: 'center',
    padding: 0,
    outline: 'none',
    width: 'max-content',
    [`@media (min-width: ${BREAKPOINTS.lg}px) and (max-width: ${BREAKPOINTS.xl}px)`]: {
      fontSize: '0.8rem',
    },
  },
  listItemDisabled: {
    opacity: 0.4,
  },
  sloganBannerWrapper: {
    backgroundColor: COLORS.whiteStain,
  },
  sloganBannerContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '8px 0',
    width: '90%',
    margin: 'auto',
  },
  sloganBanner: {
    display: 'flex',
    flexGrow: 1,
    height: 40,
    padding: '8px 0',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sloganTitle: {
    display: 'flex',
    alignItems: 'center',
    '& a': {
      color: theme.palette.common.black,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      // width: '95%',
    },
    [`@media (min-width: ${BREAKPOINTS.mdd}px)`]: {
      lineBreak: 'anywhere',
    },
  },
  navigation: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  navigationFull: {
    padding: '8px 0',
  },
  navigationMinimized: {
    padding: '15px 0',
  },
  searchButton: {
    '&:hover': {
      backgroundColor: `${COLORS.white} !important`,
    },
  },

  searchOnColoredBg: {
    '&:hover': {
      backgroundColor: '#175972 !important',
    },
  },

  /*left nav items */
  navLeft: {
    order: 3,
    position: 'relative',
  },
  yourShoppingBoard: {
    display: 'none',
  },
  brands: {
    display: 'none',
  },
  shop: {
    display: 'none',
  },
  chirpyestLogoLink: {
    display: 'none',
    height: 35,
    width: 35,
    [`@media (min-width: ${BREAKPOINTS.xl}px)`]: {
      display: 'block',
      position: 'absolute',
      top: 7,
      right: 15,
    },
  },
  chirpyestLogo: {
    maxWidth: '100%',
    maxHeight: '100%',
    position: 'relative',
  },
  howItWorks: {
    display: 'none',
  },
  theChirpyest: {
    display: 'none',
  },

  /*center nav items */
  navCenter: {
    order: 2,
    margin: 'auto',
  },
  chirpyestTextLogo: {
    height: '4vw',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      height: 47,
    },
  },
  chirpyestTextLogoMinimized: {
    height: 37,
  },
  /*right nav items */
  navRight: {
    order: 1,
  },
  menuButton: {
    background: 'transparent',
    border: 'none',
    padding: 0,
  },
  menuContainer: {
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      display: 'none',
    },
  },
  menuIcon: {
    width: 30,
    height: 14,
  },
  actionLinks: {
    display: 'none',
  },
  signInActions: {
    display: 'none',
  },
  joinContainer: {
    display: 'none',
  },
  shoppingBoardDisabled: {
    fontFamily: FONTS.Graphik.GraphikLight,
    cursor: 'default',
    marginTop: 20,
    pointerEvents: 'none',
    color: COLORS.lightGrey,
  },
  shoppingBoard: {
    color: COLORS.lightGrey,
    cursor: 'pointer',
  },
  textContainer: {
    width: 199,
    fontSize: 12,
    fontFamily: FONTS.Graphik.GraphikLight,
    fontWeight: 300,
  },
  imageContainer: {
    width: 30,
    height: 31,
    marginRight: 15,
  },

  [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
    /*left nav items */
    navLeft: {
      order: 1,
      display: 'flex',
      alignItems: 'center',
      width: '37%',
    },
    howItWorks: {
      display: 'block',
    },
    theChirpyest: {
      display: 'block',
    },
    yourShoppingBoard: {
      display: 'block',
    },
    brands: {
      display: 'block',
      marginRight: 60,
    },
    shop: {
      display: 'block',
      marginRight: 60,
    },

    /*center nav items */
    navCenter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '20%',
    },

    /*right nav items */
    navRight: {
      order: 3,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: '37%',
    },
    actionLinks: {
      display: 'block',
    },
    signInActions: {
      display: 'flex',
      marginRight: 60,
      marginLeft: 60,
      ['& > button']: {
        marginRight: 0,
      },
      [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
        marginRight: 18,
        marginLeft: 50,
      },
    },
    join: {
      marginLeft: 60,
      marginRight: 0,
    },
    blog: {
      marginRight: 60,
    },
    joinContainer: {
      display: 'block',
    },
    //this style applies when the user is logged in
    navUserIsLoggedIn: {
      justifyContent: 'space-between',
    },
  },

  bannerBreak: {
    position: 'absolute',
    right: 0,
  },
  bannerItems: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 2,
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      display: 'inline',
    },
  },
  bannerItem: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '0 20px',
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      padding: '0',
      display: 'inline',
    },
  },
  joinLinkSpan: {
    textDecoration: 'underline',
    cursor: 'pointer',
    marginRight: '10px',
  },
  copiedCaption: {
    color: 'white',
    backgroundColor: '#175972',
    width: 'fit-content',
    opacity: '0.5',
    display: 'flex',
    height: '35px',
    alignItems: 'center',
    padding: '0px 10px',
  },
  leftSubNavContainer: {
    display: 'none',
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      position: 'absolute',
      right: 0,
      top: 23,
      display: 'flex',
    },
  },
  rightSubNavContainer: {
    display: 'none',
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      position: 'absolute',
      left: 0,
      top: 23,
      display: 'flex',
    },
  },
  subListItemRight: {
    display: 'block',
    fontFamily: FONTS.Graphik.GraphikLight,
    fontSize: '0.75rem',
    textDecoration: 'none',
    background: 'transparent',
    border: 'none',
    color: COLORS.black,
    textTransform: 'uppercase',
    letterSpacing: '0.75px',
    cursor: 'pointer',
    textAlign: 'center',
    padding: '0 20px 0 0',
    outline: 'none',
    width: 'max-content',
    [`@media (min-width: ${BREAKPOINTS.lg}px) and (max-width: ${BREAKPOINTS.xl}px)`]: {
      fontSize: '0.65rem',
    },
  },
  subListItem: {
    display: 'block',
    fontFamily: FONTS.Graphik.GraphikLight,
    fontSize: '0.75rem',
    textDecoration: 'none',
    background: 'transparent',
    border: 'none',
    color: COLORS.black,
    textTransform: 'uppercase',
    letterSpacing: '0.75px',
    cursor: 'pointer',
    textAlign: 'center',
    padding: '0 0 0 20px',
    outline: 'none',
    width: 'max-content',
    [`@media (min-width: ${BREAKPOINTS.lg}px) and (max-width: ${BREAKPOINTS.xl}px)`]: {
      fontSize: '0.65rem',
    },
  },
  coloredHeader: {
    backgroundColor: '#175972',
    borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
  },
  whiteText: {
    color: COLORS.white,
  },
  whiteLogo: {
    filter: 'invert(100%)',
  },
  fullWidth: {
    [`@media (min-width: ${BREAKPOINTS.lg}px) and (max-width: ${BREAKPOINTS.xl}px)`]: {
      width: '100%',
    },
  },
  logo: {
    width: '32px',
    height: '32px',
  },
  bannerMainText: {
    fontSize: 14,
    lineHeight: 1,
  },
  bannerText: {
    margin: 0,
    fontSize: 10,
    color: COLORS.lightGrey,
  },
  installButton: {
    borderRadius: 20,
    border: 'none',
    padding: '4px 10px',
    backgroundColor: COLORS.lightTeal,
  },

  headerShell: {
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 110,
    backgroundColor: COLORS.white,
    padding: '16px 0',
    transition: 'padding 0.2s ease',
    overflowAnchor: 'none',
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      padding: '20px 0',
    },
  },
  headerShellScrolled: {
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      padding: '8px 0',
    },
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      padding: '10px 0',
    },
  },
  headerNavInner: {
    position: 'relative',
  },
  headerNavRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(5),
    padding: theme.spacing(3, 0),
    minHeight: 52,
  },
  headerLogoLink: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 0,
    gap: theme.spacing(1.5),
    flexShrink: 0,
  },
  // Bird icon is deliberately taller than the wordmark (icon-forward, minimal
  // lockup) — keep headerBirdIcon* sizes above their headerLogoImg* counterparts.
  headerBirdIcon: {
    height: 32,
    transition: 'height 0.2s ease',
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      height: 26,
    },
  },
  headerBirdIconScrolled: {
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      height: 22,
    },
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      height: 24,
    },
  },
  headerLogoImg: {
    height: 24,
    transition: 'height 0.2s ease',
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      height: 20,
    },
  },
  headerLogoImgScrolled: {
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      height: 17,
    },
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      height: 18,
    },
  },
  headerActionsDesktop: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(3),
    flex: 1,
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      display: 'flex',
    },
  },
  headerActionsMobile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      display: 'none',
    },
  },
  headerInlineLink: {
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.8125rem',
    textDecoration: 'none',
    color: theme.palette.common.black,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  headerShopTrigger: {
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.8125rem',
    textDecoration: 'none',
    background: 'transparent',
    border: 'none',
    color: theme.palette.common.black,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    cursor: 'pointer',
    padding: theme.spacing(0.5, 0),
    outline: 'none',
    whiteSpace: 'nowrap',
  },
  headerShopTriggerOpen: {
    textDecoration: 'underline',
  },
  headerSignInCta: {
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.8125rem',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: theme.spacing(0.5, 1),
    outline: 'none',
    whiteSpace: 'nowrap',
  },
  headerToolsTriggerLabel: {
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.8125rem',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
  },
  headerAvatar: {
    width: 32,
    height: 32,
    border: `1px solid ${COLORS.ashGrey}`,
    transition: 'border-color 0.2s ease',
  },
  headerAvatarImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '50%',
  },
  headerMobileIconBtn: {
    padding: theme.spacing(1),
  },
  headerPopoverRoot: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },
  headerPopoverTrigger: {
    background: 'none',
    border: 'none',
    padding: theme.spacing(0.5),
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    color: 'inherit',
    outline: 'none',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.8,
    },
  },
  headerPopoverPanel: {
    position: 'absolute',
    top: '100%',
    marginTop: theme.spacing(1),
    minWidth: 260,
    backgroundColor: COLORS.white,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    padding: theme.spacing(0.5, 0),
    zIndex: 200,
    maxHeight: 'min(420px, 80vh)',
    overflowY: 'auto',
    animation: '$headerPopoverIn 0.16s ease-out',
  },
  '@keyframes headerPopoverIn': {
    from: {
      opacity: 0,
      transform: 'translateY(-4px) scale(0.98)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
    },
  },
  headerPopoverPanelLeft: {
    left: 0,
    transformOrigin: 'top left',
  },
  headerPopoverPanelRight: {
    right: 0,
    transformOrigin: 'top right',
  },
  headerPopoverLink: {
    display: 'block',
    padding: theme.spacing(1.25, 2),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.8125rem',
    textDecoration: 'none',
    color: COLORS.black,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    '&:hover': {
      backgroundColor: COLORS.whiteStain,
    },
  },
  headerPopoverButton: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: theme.spacing(1.25, 2),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.8125rem',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: COLORS.black,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    '&:hover': {
      backgroundColor: COLORS.whiteStain,
    },
  },

  drawerPaper: {
    width: '100%',
    maxHeight: '100vh',
    backgroundColor: COLORS.white,
  },
  mobileMenu: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    width: '100%',
    maxWidth: WIDTH_DIMENSIONS.max,
    margin: '0 auto',
    padding: theme.spacing(2, 3.5, 3),
    backgroundColor: COLORS.white,
  },
  mobileMenuHeader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 56,
    marginBottom: theme.spacing(1),
  },
  mobileMenuCloseBtn: {
    position: 'absolute',
    left: 0,
    padding: theme.spacing(0.5),
    color: COLORS.black,
  },
  mobileMenuLogoLink: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 0,
  },
  mobileMenuLogo: {
    height: 42,
  },
  mobileNav: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 16,
  },
  mobileNavLink: {
    display: 'block',
    padding: theme.spacing(2, 0, 2, 1),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    lineHeight: '23px',
    letterSpacing: '0.88px',
    textDecoration: 'none',
    color: COLORS.black,
    textTransform: 'uppercase',
    borderTop: `1px solid ${COLORS.black}`,
    backgroundColor: COLORS.white,
  },
  mobileNavSectionLabel: {
    padding: theme.spacing(2, 0, 2, 1),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    lineHeight: '23px',
    letterSpacing: '0.88px',
    color: COLORS.black,
    textTransform: 'uppercase',
    borderTop: `1px solid ${COLORS.black}`,
    backgroundColor: COLORS.white,
  },
  mobileNavToggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(2, 0, 2, 1),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    lineHeight: '23px',
    letterSpacing: '0.88px',
    color: COLORS.black,
    textTransform: 'uppercase',
    background: COLORS.white,
    border: 'none',
    borderTop: `1px solid ${COLORS.black}`,
    textAlign: 'left',
    cursor: 'pointer',
    outline: 'none',
  },
  mobileNavToggleIcon: {
    fontSize: '1.75rem',
    marginLeft: theme.spacing(1),
    color: COLORS.black,
  },
  mobileNavChildren: {
    display: 'flex',
    flexDirection: 'column',
  },
  mobileNavSubLink: {
    display: 'block',
    padding: theme.spacing(2, 0, 2, 3.75),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    lineHeight: '23px',
    textDecoration: 'none',
    color: COLORS.black,
    textTransform: 'lowercase',
    letterSpacing: '0.02em',
    borderTop: `1px solid ${COLORS.black}`,
    backgroundColor: COLORS.whiteStain,
    '& a': {
      color: COLORS.black,
      textDecoration: 'none',
    },
  },
  mobileNavCopyLink: {
    padding: 0,
    font: 'inherit',
    color: COLORS.black,
    textDecoration: 'underline',
    textTransform: 'lowercase',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
  },
  mobileActions: {
    paddingTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    borderTop: `1px solid ${COLORS.black}`,
  },
  mobileSignOutButton: {
    display: 'block',
    width: '100%',
    padding: theme.spacing(2.5, 2.5),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    fontWeight: 600,
    textTransform: 'lowercase',
    letterSpacing: '0.02em',
    color: COLORS.black,
    backgroundColor: COLORS.white,
    border: `1px solid ${COLORS.black}`,
    borderRadius: 0,
    cursor: 'pointer',
    outline: 'none',
    marginBottom: theme.spacing(4),
  },
  secondaryButton: {
    display: 'block',
    textAlign: 'center',
    padding: theme.spacing(1.5, 2),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    textDecoration: 'none',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: COLORS.black,
    border: `1px solid ${COLORS.black}`,
    borderRadius: 4,
    '&:hover': {
      backgroundColor: COLORS.whiteStain,
    },
  },
  primaryButton: {
    display: 'block',
    width: '100%',
    padding: theme.spacing(1.5, 2),
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: COLORS.white,
    backgroundColor: COLORS.black,
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.88,
    },
  },
  desktopLinks: {
    display: 'none',
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      display: 'flex',
      gap: '40px',
      alignItems: 'center',
      paddingLeft: '20px',
    },
  },
}))
